import { useEffect } from 'react'

interface Event {
  reason: {
    message: string
  }
}
const useUnHandlerejection = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const handleChunkError = (event: Event) => {
      if (
        event?.reason?.message?.includes('Failed to load script') ||
        event?.reason?.message?.includes("Failed to execute 'removeChild'") ||
        event?.reason?.message?.includes('ChunkLoadError') ||
        event?.reason?.message?.includes('Loading chunk') ||
        event?.reason?.message?.includes('AggregateError: No error message') ||
        event?.reason?.message?.includes('ERR_INVALID_STATE') ||
        event?.reason?.message?.includes('Unable to enqueue') ||
        event?.reason?.message?.includes('Invalid state')
      ) {
        console.log('🚀 ~ global handleRej ~ reload')
        if (typeof window !== 'undefined') {
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        }
      }
    }

    window.addEventListener('unhandledrejection', handleChunkError)

    return () => {
      if (typeof window === 'undefined') return
      window.removeEventListener('unhandledrejection', handleChunkError)
    }
  }, [])
}
export default useUnHandlerejection
